import React from "react";
import List from "@mui/material/List";
import NotificationItem from "./NotificationItem";

export default function NotificationList({ notifications, onItemClick }) {
  return (
    <List disablePadding>
      {notifications.map((n) => (
        <NotificationItem key={n.id} notification={n} onClick={onItemClick} />
      ))}
    </List>
  );
}
